import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import classnames from 'classnames'
import {
    Box,
    Grid,
    Breadcrumbs,
    Tabs,
    Tab,
} from '@material-ui/core'
import {
    NavigateNext as NavigateNextIcon,
} from '@material-ui/icons'
import { withStyles } from '@material-ui/styles'

// styles
import useStyles from './styles'

// components
import Header from '../Header'
import Sidebar from '../Sidebar'
import Widget from '../Widget'
import { Typography } from '../../components/Wrappers'

// pages
import Dashboard from '../../pages/dashboard'
import Users from '../../pages/users'
import Subscription from '../../pages/Subscription'
import UserDetails from '../../pages/users/UserDetails'
import AddEditPrivacyPolicy from "../../pages/privacyPolicy/AddEditPrivacyPolicy"
import ContactUs from "../../pages/Contact_Us/Contact"
import AddEditHelp from "../../pages/Help/AddEditHelp"
import FeedBack from '../../pages/Feedback/feedBack'
import CurrencyConvert from '../../pages/CurrencyConverter/CurrencyConvert'

// context
import { useLayoutState } from '../../context/LayoutContext'
import { DashboardProvider } from '../../context/DashboardContext'
import { UsersProvider } from '../../context/UsersContext'
import { PagesProvider } from '../../context/PagesContext'
import { FeedbackProvider } from '../../context/FeedbackContext'

//Sidebar structure
import structure from '../Sidebar/SidebarStructure'
import EditTermsAndCondition from '../../pages/TermsAndCondition/EditTermsAndCondition'
import { CurrencyConverterProvider } from '../../context/CurrenyConverterContext'
import { ReferralCodeDataProvider } from '../../context/ReferralCodeContext'
import ReferralCodeManagement from '../../pages/ReferralCode/ReferralCodeManagement'
import Addreferralcode from '../../pages/ReferralCode/AddReferralCode'
import { SubscriberUsersProvider } from '../../context/SubscribeContext'

// Tab styling

const CustomTab = withStyles(theme => ({
    root: {
        minWidth: 72,
        textTransform: 'none',
        fontWeight: 400,
    },
}))(props => <Tab {...props} />)

function Layout(props) {
    const classes = useStyles()
    const [value, setValue] = React.useState(2)
    // global
    var layoutState = useLayoutState()

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        }
    }

    return (
        <div className={classes.root}>
            <Header history={props.history} />
            <Sidebar structure={structure} />
            <div
                className={classnames(classes.content, {
                    [classes.contentShift]: layoutState.isSidebarOpened,
                })}
            >
                <Widget
                    disableWidgetMenu
                    inheritHeight
                    className={classes.margin}
                    bodyClass={classes.navPadding}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        wrap={'nowrap'}
                        style={{ overflowX: 'auto' }}
                    >
                        {structure.map(c => {
                            if (
                                !c.children &&
                                window.location.hash.includes(c.link) &&
                                c.link
                            ) {
                                return (
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        key={c.id}
                                    >
                                        <Breadcrumbs aria-label="breadcrumb">
                                            <Typography variant="h4">
                                                {c.label}
                                            </Typography>
                                        </Breadcrumbs>
                                        {window.location.hash.includes(
                                            '/app/dashboard'
                                        ) && (
                                                <Tabs
                                                    value={value}
                                                    onChange={handleChange}
                                                    aria-label="simple tabs example"
                                                    variant="scrollable"
                                                    scrollButtons="auto"
                                                    style={{ marginLeft: 38 }}
                                                >
                                                    <CustomTab
                                                        label="Today"
                                                        {...a11yProps(0)}
                                                    />
                                                    <CustomTab
                                                        label="This week"
                                                        {...a11yProps(1)}
                                                    />
                                                    <CustomTab
                                                        label="This month"
                                                        {...a11yProps(2)}
                                                    />
                                                    <CustomTab
                                                        label="This year"
                                                        {...a11yProps(3)}
                                                    />
                                                </Tabs>
                                            )}
                                    </Box>
                                )
                            } else if (c.children) {
                                return c.children.map(currentInner => {
                                    if (
                                        window.location.hash.includes(
                                            currentInner.link
                                        )
                                    ) {
                                        return (
                                            <Breadcrumbs
                                                separator={
                                                    <NavigateNextIcon fontSize="small" />
                                                }
                                                aria-label="breadcrumb"
                                                key={c.id}
                                            >
                                                <Typography variant={'h6'}>
                                                    {c.label}
                                                </Typography>
                                                <Typography
                                                    variant={'h6'}
                                                    color="primary"
                                                >
                                                    {currentInner.label}
                                                </Typography>
                                            </Breadcrumbs>
                                        )
                                    } else {
                                        return null
                                    }
                                })
                            } else {
                                return null
                            }
                        })}
                    </Grid>
                </Widget>
                <Switch>

                    <Route exact path={process.env.PUBLIC_URL + "/app/dashboard"} >
                        <DashboardProvider><Dashboard /></DashboardProvider>
                    </Route>

                    <Route exact path={process.env.PUBLIC_URL + "/app/users"} >
                        <UsersProvider> <Users /> </UsersProvider>
                    </Route>

                    <Route exact path={process.env.PUBLIC_URL + "/app/subscription"} >
                        <SubscriberUsersProvider><Subscription /></SubscriberUsersProvider>
                    </Route>

                    <Route exact path={process.env.PUBLIC_URL + "/app/users/details"} >
                        <UsersProvider> <UserDetails /> </UsersProvider>
                    </Route>

                    <Route exact path={process.env.PUBLIC_URL + "/app/pages/addEditprivacy"} >
                        <PagesProvider> <AddEditPrivacyPolicy /> </PagesProvider>
                    </Route>

                    {/* <Route exact path={process.env.PUBLIC_URL + "/app/pages/contactus"} >
                        <PagesProvider> <ContactUs/> </PagesProvider>
                    </Route> */}

                    <Route exact path={process.env.PUBLIC_URL + "/app/pages/addedithelp"} >
                        <PagesProvider> <AddEditHelp /> </PagesProvider>
                    </Route>

                    <Route exact path={process.env.PUBLIC_URL + "/app/pages/editterms"} >
                        <PagesProvider> <EditTermsAndCondition /> </PagesProvider>
                    </Route>

                    <Route exact path={process.env.PUBLIC_URL + "/app/feedback"} >
                        <FeedbackProvider> <FeedBack /> </FeedbackProvider>
                    </Route>

                    <Route exact path={process.env.PUBLIC_URL + "/app/currencyconverter"} >
                        <CurrencyConverterProvider> <CurrencyConvert /> </CurrencyConverterProvider>
                    </Route>

                    <Route exact path={process.env.PUBLIC_URL + "/app/referralcodes"} >
                        <ReferralCodeDataProvider> <ReferralCodeManagement /> </ReferralCodeDataProvider>
                    </Route>

                    <Route exact path={process.env.PUBLIC_URL + "/app/referralcodes/addreferralcode"} >
                        <ReferralCodeDataProvider> <Addreferralcode /> </ReferralCodeDataProvider>
                    </Route>

                </Switch>
            </div>
        </div>
    )
}

export default withRouter(Layout)
